<template>
  <div class="box box--quiz1">
    <div class="box-img-wrapper">
      <ImageWrapper :file="box.idPicture" :key="box.idPicture"></ImageWrapper>
    </div>
    <div class="box-inner">
      <span class="box-tag" v-if="! box.isFinished">{{box.endDate | daysToVote}}</span>
      <span class="box-tag-completed" v-if="box.isFinished">Quiz completed</span>
      <span class="box-title">{{box.name}}</span>
      <p v-if="box.lead">{{box.lead}}</p>
      <div class="box-bottom2"><button v-if="! box.isFinished" @click="openPopup">Start quiz</button></div>
    </div>
    <transition name="fade">
      <PopupQuizStart v-if="popupQuizStart" :quiz="box"  @closePopup="closePopup" />
    </transition>
  </div>
</template>

<script>
import PopupQuizStart from "@/components/quiz/PopupQuizStart";
import ImageWrapper from "@/components/general/ImageWrapper";
export default {
name: "QuizBox",
  props: ['box'],
  components: {ImageWrapper, PopupQuizStart},
  data() {
    return {
      popupQuizStart: false,
    }
  },
  methods: {
    openPopup (e) {
      e.preventDefault()
      this.popupQuizStart = true
      document.querySelector('body').classList.add('nooverflow')
    },
    closePopup () {
      this.popupQuizStart = false
      document.querySelector('body').classList.remove('nooverflow')
    }
  }
}
</script>

<style scoped>

</style>